import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export class ApiBaseService {
  private path;
  private httpService;

  constructor(http: HttpClient, endpoint: string) {
    this.path = endpoint;
    this.httpService = http;
  }

  get(params?: any, path?: string): Observable<any> {
    const url = `${environment.apiUrl}${this.path}${path ? '/' + path : ''}`;
    return this.httpService.get(url, {
      params,
    });
  }

  getOne(id: any, params?: any): Observable<any> {
    return this.httpService.get(
      `${environment.apiUrl}${this.path}/${id}`,
      params,
    );
  }

  post(body: any, params?: any): Observable<any> {
    const options = params ? { params: new HttpParams({ fromObject: params }) } : {};
    return this.httpService.post(
      `${environment.apiUrl}${this.path}`,
      body,
      options,
    );
  }

  postBulk(body: any, params?: any): Observable<any> {
    return this.httpService.post(
      `${environment.apiUrl}${this.path}/bulk`,
      body,
      params,
    );
  }

  patch(body: any, id: any, params?: any): Observable<any> {
    return this.httpService.patch(
      `${environment.apiUrl}${this.path}/${id}`,
      body,
      params,
    );
  }

  put(body: any, id: any, path?: string): Observable<any> {
    const url = `${environment.apiUrl}${this.path}${
      path ? '/' + path : ''
    }/${id}`;
    return this.httpService.put(url, body);
  }

  delete(id: any, path?: string): Observable<any> {
    const url = `${environment.apiUrl}${this.path}${
      path ? '/' + path : ''
    }/${id}`;
    return this.httpService.delete(url);
  }

  // static getStatic(httpService: HttpClient, path: string, params?: any){
  //   return httpService.get<any>(`${environment.apiUrl}${path}`,params);
  // }
}
